import { useIntl } from "react-intl";

import BookIcon from "@atlaskit/icon/core/book-with-bookmark";
import CompassIcon from "@atlaskit/icon/core/compass";
import PersonIcon from "@atlaskit/icon/core/person-avatar";

import { useRoutes } from "@/components/fastshift/src/common/hooks";

import { FASTSHIFT_PATH_KEYS } from "../../../routes/constants";
import { getDomainScopedPathKeys } from "../../../routes/utils";
import { messages } from "../messages";

type NavLinkItem = {
    key: FASTSHIFT_PATH_KEYS;
    label: string;
    icon: React.ReactElement;
    link: string | null;
};

export const usePageNavLinks = () => {
    const { fullPathname, paths } = useRoutes();
    const { formatMessage } = useIntl();
    // note that the order of this navLinks array determines
    // the order of links displayed inside the sidenav component
    const navLinks: NavLinkItem[] = [
        // (Ordered) Partner Scoped Links
        {
            key: FASTSHIFT_PATH_KEYS.SELECTION,
            label: formatMessage(messages.customersNavLabel),
            link: paths.selection,
            icon: <PersonIcon label="" />
        },
        {
            key: FASTSHIFT_PATH_KEYS.RESOURCES_PARTNER_SCOPED,
            label: formatMessage(messages.resourcesNavLabel),
            link: paths.partnerResources,
            icon: <BookIcon label="" />
        },
        // (Ordered) Domain Scoped Links
        {
            key: FASTSHIFT_PATH_KEYS.OVERVIEW,
            label: formatMessage(messages.forYouNavLabel),
            link: paths.domainScopedOverview,
            icon: <PersonIcon label="" />
        },
        {
            key: FASTSHIFT_PATH_KEYS.PLANNING,
            label: formatMessage(messages.migrationPlanningNavLabel),
            link: paths.domainScopedPlanning,
            icon: <CompassIcon label="" />
        },
        {
            key: FASTSHIFT_PATH_KEYS.RESOURCES_DOMAIN_SCOPED,
            label: formatMessage(messages.resourcesNavLabel),
            link: paths.domainScopedResources,
            icon: <BookIcon label="" />
        }
    ];

    const domainScopedPathKeys = getDomainScopedPathKeys();
    // find the key of the navlinks object with a link that matches the pathname
    const currentPageKey: FASTSHIFT_PATH_KEYS | undefined = navLinks.find(
        (navLink) => navLink.link === fullPathname
    )?.key as FASTSHIFT_PATH_KEYS;

    if (domainScopedPathKeys.includes(currentPageKey || "")) {
        return {
            pageKey: currentPageKey,
            links: [
                ...navLinks.filter((navLink) =>
                    domainScopedPathKeys.includes(navLink.key)
                )
            ],
            isOnDomainScopedPage: true
        };
    }

    return {
        pageKey: currentPageKey,
        links: [
            ...navLinks.filter(
                (navLink) => !domainScopedPathKeys.includes(navLink.key)
            )
        ],
        isOnDomainScopedPage: false
    };
};
